import {Browser} from '@clappr/core'

export {default as classNames} from './styles.scss'
export {default} from './template'

export const holdable = false
export const shiftable = true
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const SHOW_TIMEOUT = Browser.isMobile ? null : 3e3
export const SHOW_ON_MUTE = true
export const SHOW_IF_NO_SOUND = Browser.isMobile
